import classes from './Footer.module.scss';

function Footer() {
    return (
        <footer className={classes['footer']}>
            <a href="https://jagdishchopde.wixsite.com/profile" target="_blank" rel="noreferrer" className={classes['footer__title']}>&copy;  HiJack Studios - 2021</a>
        </footer>
    )
}

export default Footer
